<template>
    <div class="operationLog">
        <Head-view :showStyle="8"></Head-view>
        <div class="main">
            <div class="breadcrumb">操作日志</div>

            <div class="showTba">
                <div class="tableBox">
                    <el-table
                        :data="tableData"
                        style="
                            width: 100%;
                            border: 1px solid rgba(237, 244, 255, 1);
                        "
                        height="680"
                        :cell-style="{ textAlign: 'center' }"
                        :header-cell-style="{
                            textAlign: 'center',
                            backgroundColor: 'rgba(237, 244, 255, 0.8)',
                        }"
                    >
                        <el-table-column
                            prop="loginTime"
                            label="时间"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="username"
                            label="账号"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="staffName"
                            label="人员"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="operation"
                            label="操作"
                            width="180"
                        >
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HeadView from "@/components/HeadView";
export default {
    name: "operationLog",
    data() {
        return {
            tableData: [],
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        this.getHistoryLand();
    },

    methods: {
        getHistoryLand() {
            let data = {
                token: this.getCookie(),
                insId: this.insId,
            };

            this.request
                .post(this.baseUrl + "institution/getLoginHistoryList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.tableData = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    console.log(res);
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取历史记录失败",
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.operationLog {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .showTba {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            margin-right: 7px;
            padding: 24px 0 20px 24px;
            height: 692px;
            background: #fff;
            overflow-y: auto;
        }
    }
}

.showTba {
    /deep/ .el-table__cell {
        font-size: 12px;
        font-weight: bold;
    }

    /deep/ .gutter {
        background-color: rgba(237, 244, 255, 0.8);
    }
}
</style>